import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms32e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres32e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqst.replace(/\//g, '') : ''),
        p_dtereq_en: (typeof searchParams.dtereqen.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqen.replace(/\//g, '') : ''),
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codempid_query: (typeof searchParams.codempid !== 'undefined' && searchParams.codempid !== '' ? searchParams.codempid : '%')
      }
    }
    return instance().get(endpoint + '/hres32e/index', { params: sendParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres32e/dropdowns')
  },
  getDropdowns2 () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres32e/dropdowns2')
  },
  getDetailIndex () {
    if (isMock) return generator(mocker.detailIndex())
    return instance().get(endpoint + '/hres32e/detailIndex')
  },
  getDetailTopic () {
    if (isMock) return generator(mocker.detailTopicx())
    return instance().get(endpoint + '/hres32e/detailTopic')
  },
  getDetailTab1Crate (paramSearchDetail) {
    if (isMock) return generator(mocker.detailTab1())
    if (paramSearchDetail) {
      let searchParams = {
        p_dtereq: paramSearchDetail.dtereq,
        p_codempid_query: paramSearchDetail.codempid_query
      }
      const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_codempid_query
      return instance().get(endpoint + '/hres32e/detail1Create/' + params)
    } else {
      let mockTab1 = {
        codtitle: '',
        desc_codtitle: '',
        name: '',
        last: '',
        n_codtitle: '',
        n_name: '',
        n_last: '',
        desnote: '',
        n_codtitle_flg: '',
        n_name_flg: '',
        n_last_flg: '',
        codempid_query: ''
      }
      return generator({
        detail1: mockTab1
      })
    }
  },
  getDetailTab2_6Crate (paramSearchDetail) {
    if (isMock) return generator(mocker.detailTab2_6())
    if (paramSearchDetail) {
      let searchParams = {
        p_dtereq: paramSearchDetail.dtereq,
        p_codempid_query: paramSearchDetail.codempid_query
      }
      const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_codempid_query
      return instance().get(endpoint + '/hres32e/detail2to6Create/' + params)
    } else {
      let mockDetail2Tab1 = {
        adrreg: '',
        codsubdistr: '',
        coddistr: '',
        codprovr: '',
        codcntyr: '',
        codpostr: '',
        adrcont: '',
        codsubdistc: '',
        coddistc: '',
        codprovc: '',
        codcntyc: '',
        codpostc: '',
        numtelec: '',
        email_emp: '',
        desc_codsubdistr: '',
        desc_coddistr: '',
        desc_codprovr: '',
        desc_codcntyr: '',
        desc_codsubdistc: '',
        desc_coddistc: '',
        desc_codprovc: '',
        desc_codcntyc: '',
        adrrege_flg: '',
        adrregt_flg: '',
        adrreg3_flg: '',
        adrreg4_flg: '',
        adrreg5_flg: '',
        codsubdistr_flg: '',
        coddistr_flg: '',
        codprovr_flg: '',
        codcntyr_flg: '',
        codpostr_flg: '',
        adrconte_flg: '',
        adrcontt_flg: '',
        adrcont3_flg: '',
        adrcont4_flg: '',
        adrcont5_flg: '',
        codsubdistc_flg: '',
        coddistc_flg: '',
        codprovc_flg: '',
        codcntyc_flg: '',
        codpostc_flg: '',
        numtelec_flg: '',
        email_emp_flg: '',
        codempid_query: ''
      }

      let mockDetail2Tab2 = {
        numoffid: '',
        adrissue: '',
        codprovi: '',
        dteoffid: '',
        numlicid: '',
        dtelicid: '',
        numpasid: '',
        dtepasid: '',
        numprmid: '',
        dteprmst: '',
        dteprmen: '',
        stamarry: '',
        stamilit: '',
        desc_codprovi: '',
        stamilit_flg: '',
        numoffid_flg: '',
        adrissue_flg: '',
        codprovi_flg: '',
        dteoffid_flg: '',
        numlicid_flg: '',
        dtelicid_flg: '',
        numpasid_flg: '',
        dtepasid_flg: '',
        numprmid_flg: '',
        dteprmst_flg: '',
        dteprmen_flg: '',
        stamarry_flg: '',
        codempid_query: ''
      }

      let mockDetail2Tab3 = {
        namfathr: '',
        codfnatn: '',
        codfrelg: '',
        codfoccu: '',
        numofidf: '',
        nammothr: '',
        codmnatn: '',
        codmrelg: '',
        codmoccu: '',
        numofidm: '',
        namcont: '',
        adrcont1: '',
        codpost: '',
        numtele: '',
        numfax: '',
        email: '',
        desrelat: '',
        desc_codfnatn: '',
        desc_codfrelg: '',
        desc_codfoccu: '',
        desc_codmnatn: '',
        desc_codmrelg: '',
        desc_codmoccu: '',
        namfathr_flg: '',
        codfnatn_flg: '',
        codfrelg_flg: '',
        codfoccu_flg: '',
        numofidf_flg: '',
        nammothr_flg: '',
        codmnatn_flg: '',
        codmrelg_flg: '',
        codmoccu_flg: '',
        numofidm_flg: '',
        namcont_flg: '',
        adrcont1_flg: '',
        codpost_flg: '',
        numtele_flg: '',
        numfax_flg: '',
        email_flg: '',
        desrelat_flg: '',
        codempid_query: ''
      }

      let mockDetail2Tab4 = {
        codbank: '',
        numbank: '',
        codbank2: '',
        numbank2: '',
        amtbank: '',
        desc_codbank: '',
        desc_codbank2: '',
        codbank_flg: '',
        numbank_flg: '',
        codbank2_flg: '',
        numbank2_flg: '',
        amtbank_flg: '',
        codempid_query: ''
      }

      let mockDetail2Tab5 = {
        codtitle: '',
        namfirst: '',
        namlast: '',
        numspid: '',
        dtespbd: '',
        codspocc: '',
        desnoffi: '',
        dtemarry: '',
        desplreg: '',
        codsppro: '',
        codspcty: '',
        desnote: '',
        desc_codspocc: '',
        desc_codsppro: '',
        desc_codspcty: '',
        numspid_flg: '',
        dtespbd_flg: '',
        codspocc_flg: '',
        desnoffi_flg: '',
        dtemarry_flg: '',
        desplreg_flg: '',
        codsppro_flg: '',
        codspcty_flg: '',
        desnote_flg: '',
        codempid_query: ''
      }

      let mockTab5Detail = {
        typrewd: '',
        desrewd1: '',
        numhmref: '',
        typrewd_flg: '',
        desrewd1_flg: '',
        numhmref_flg: '',
        codempid_query: ''
      }

      return generator({
        detail2: {
          tab1: mockDetail2Tab1,
          tab2: mockDetail2Tab2,
          tab3: mockDetail2Tab3,
          tab4: mockDetail2Tab4,
          tab5: mockDetail2Tab5,
          tab6: {
            table1: {
              total: 0,
              rows: []
            },
            table2: {
              total: 0,
              rows: []
            },
            table3: {
              total: 0,
              rows: []
            }
          },
          tab7: {
            total: 0,
            rows: []
          }
        },
        detail3: {
          total: 0,
          rows: []
        },
        detail4: {
          total: 0,
          rows: []
        },
        detail5: mockTab5Detail,
        detail6: {
          total: 0,
          rows: []
        }
      })
    }
  },
  getDetailTab1 (detailParams) {
    if (isMock) return generator(mocker.detailTab1())
    let searchParams = {
      p_dtereq: detailParams.dtereq,
      p_numseq: detailParams.numseq,
      p_typchg: detailParams.typchg,
      p_codempid_query: detailParams.codempid_query
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq + '/' + searchParams.p_typchg + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres32e/detail1/' + params)
  },
  getDetailTab2_6 (detailParams) {
    if (isMock) return generator(mocker.detailTab2_6())
    let searchParams = {
      p_dtereq: detailParams.dtereq,
      p_numseq: detailParams.numseq,
      p_typchg: detailParams.typchg,
      p_codempid_query: detailParams.codempid_query
    }
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq + '/' + searchParams.p_typchg + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres32e/detail2to6/' + params)
  },
  postDetail1Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail1Save', saveParams)
  },
  postDetail2Tab1Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab1Save', saveParams)
  },
  postDetail2Tab2Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab2Save', saveParams)
  },
  postDetail2Tab3Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab3Save', saveParams)
  },
  postDetail2Tab4Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab4Save', saveParams)
  },
  postDetail2Tab5Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab5Save', saveParams)
  },
  postDetail2Tab6Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab6Save', saveParams)
  },
  postDetail2Tab7Save (dataRowsHasFlg) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'typdoc': dataRow.typdoc,
        'namdoc': dataRow.namdoc,
        'dterecv': dataRow.dterecv.replace(/\//g, ''),
        'dtedocen': dataRow.dtedocen.replace(/\//g, ''),
        'numdoc': dataRow.numdoc,
        'filedoc': dataRow.filedoc,
        'desnote': dataRow.desnote,
        'status': dataRow.status,
        'desc_status': dataRow.desc_status,
        'codempid_query': dataRow.codempid_query
      })
    }
    var saveParams = {
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail2Tab7Save', saveParams)
  },
  postDetail3Save (dataRowsHasFlg) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'codedlv': dataRow.codedlv,
        'coddglv': dataRow.coddglv,
        'codmajsb': dataRow.codmajsb,
        'codminsb': dataRow.codminsb,
        'codinst': dataRow.codinst,
        'codcount': dataRow.codcount,
        'numgpa': dataRow.numgpa,
        'stayear': dataRow.stayear,
        'dtegyear': dataRow.dtegyear,
        'flgeduc': dataRow.flgeduc,
        'codempid_query': dataRow.codempid_query
      })
    }
    var saveParams = {
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail3Save', saveParams)
  },
  postDetail4Save (dataRowsHasFlg) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'namchild': dataRow.namchild,
        'numoffid': dataRow.numoffid,
        'dtechbd': dataRow.dtechbd.replace(/\//g, ''),
        'namsex': dataRow.namsex,
        'codeduc2': dataRow.codedlv,
        'codempid_query': dataRow.codempid_query
      })
    }
    var saveParams = {
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail4Save', saveParams)
  },
  postDetail5Save (saveParams) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail5Save', saveParams)
  },
  postDetail6Save (dataRowsHasFlg) {
    var params = []
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      var dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codempid': dataRow.codempid,
        'p_dtereq': dataRow.dtereq,
        'p_numseq': dataRow.numseq,
        'numseq': dataRow.numseq,
        'dtetrain': dataRow.dtetrain.replace(/\//g, ''),
        'destrain': dataRow.destrain,
        'dtetren': dataRow.dtetren.replace(/\//g, ''),
        'desplace': dataRow.desplace,
        'desinstu': dataRow.desinstu,
        'codempid_query': dataRow.codempid_query
      })
    }
    var saveParams = {
      'p_param': JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres32e/detail6Save', saveParams)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres32e/cancel', cancelParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms32e/index.js